import { useMemo } from 'react'
import {
  recordClick,
  recordErrorImpression,
  recordImpression,
  logActivity,
  recordClientClick,
  recordClientEvent,
} from 'utils/fpti'

import usePageImpression from './usePageImpression'

export default function useAnalytics(data: any = {}, options: any = {}) {
  usePageImpression(data, options)

  return useMemo(() => {
    const getStub = (page) => data?.page || page
    const recordErrorAsImpression = (logImpression = true) => ({ page, ...restTags }: any) =>
      recordErrorImpression(
        getStub(page),
        {
          errorPage: `${getStub(page)}:error`,
          ...restTags,
        },
        !logImpression,
      )

    return {
      // recordClick is deprecated, please use recordClientClick
      recordClick: ({ page, link, ...restTags }: any) => recordClick(getStub(page), link, restTags),
      recordClientClick: (opts: any) => recordClientClick(opts),
      // logActivity is deprecated, please use recordClientEvent
      logActivity: ({ page, ...restTags }: any) => logActivity(getStub(page), restTags),
      recordClientEvent: ({ eventName, ...restTags }: any) => recordClientEvent(eventName, restTags),
      recordImpression: ({ page, ...restTags }: any) => recordImpression(getStub(page), restTags),
      recordErrorImpression: recordErrorAsImpression(),
      recordErrorActivity: recordErrorAsImpression(false),
    }
  }, [data?.page])
}
